import { defineMessages, FormattedMessage } from 'react-intl';

type Unit = 'mm' | 'inch';

const intlPrefix = 'strapAddToBagModal';

export const defined = defineMessages({
  addAStrap: {
    id: `${intlPrefix}.addAStrap`,
    defaultMessage: 'Add a strap',
  },
  getABuckleForYourStrap: {
    id: `${intlPrefix}.getABuckleForYourStrap`,
    defaultMessage: 'Get an extra buckle for your strap',
  },
  adjustSize: {
    id: `${intlPrefix}.adjustSize`,
    defaultMessage: 'Adjust the size of your strap',
  },
  noBucklesForSelection: {
    defaultMessage: 'No buckles currently available for selection.',
    id: 'noBuckles',
  },
  personalizeYourStrap: {
    defaultMessage: 'Personalize your strap',
    id: `${intlPrefix}.personalizeYourStrap`,
  },
});

export const NiceToHaveTopDescription = (
  <FormattedMessage
    defaultMessage='The perfect tool to easily change a strap on your Breitling. Use the forked end to release the spring bar from the lugs, and to place the buckle on your new strap when needed.'
    id={`${intlPrefix}.niceToHaveTopDescription`}
  />
);

export const NiceToHaveBottomDescription = (
  <FormattedMessage
    defaultMessage='Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam'
    id={`${intlPrefix}.niceToHaveBottomDescription`}
  />
);

export const MeasuringText = (min: number, max: number, unit: Unit) => (
  <FormattedMessage
    defaultMessage='Fits a wrist measuring between {min} and {max} {unit}'
    id={`${intlPrefix}.measuringText`}
    values={{ min, max, unit }}
  />
);
